import { Injectable } from '@angular/core';
import * as S3 from 'aws-sdk/clients/s3';
import { LocalSaveService }  from './local-save-service.service'
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
  
export class UploadServiceService {

  FOLDER = 'scriptsPGV/';
 
  constructor(public localSave: LocalSaveService, private configService: ConfigService) { }

  uploadfile(file) {

    const awsCfg = this.configService.getAwsConfig();
    const bucket = new S3(
      {
        accessKeyId: awsCfg ? awsCfg.accessKeyId : '',
        secretAccessKey: awsCfg ? awsCfg.secret : '',
        region: (awsCfg ? awsCfg.region : '') || 'us-east-1'
      }
    );
 
    const params = {
      Bucket: 'twillbit',
      Key: this.FOLDER + file.name,
      Body: file
    };

    return new Promise (resolve => {
      bucket.upload(params, function (err, data) {
        if (err) {
          resolve(false);
        }
        resolve(data);
      });
    });
  }
}
